{
  "v1.compte.acces.aucun_profil": "Aucun profil.",
  "v1.compte.acces.droits": "{{n}} droits effectifs",
  "v1.compte.acces.herite": "hérité",
  "v1.compte.acces.pose": "posé",
  "v1.compte.acces.propriete": "par propriété",
  "v1.compte.acces.titre": "Mes accès par espace",
  "v1.compte.acces.tronque": "Liste tronquée : seuls les premiers espaces sont montrés.",
  "v1.compte.acces.vide": "Aucun accès à un espace.",
  "v1.compte.annuler": "Annuler",
  "v1.compte.applications.echec": "L’application n’a pas été révoquée.",
  "v1.compte.applications.revoquee": "Application révoquée.",
  "v1.compte.applications.revoquer": "Révoquer",
  "v1.compte.applications.revoquer_nom": "Révoquer l’application {{nom}}",
  "v1.compte.applications.titre": "Applications autorisées",
  "v1.compte.applications.vide": "Aucune application autorisée.",
  "v1.compte.apropos.guide": "Ouvrir le guide",
  "v1.compte.apropos.texte": "Pour toute question, consultez le guide ou l’administration de votre organisation.",
  "v1.compte.apropos.titre": "À propos et support",
  "v1.compte.code.ANNUAIRE_INDISPONIBLE": "L’annuaire des comptes est indisponible : réessayez plus tard.",
  "v1.compte.code.APPLICATION_INTROUVABLE": "Cette application n’est plus autorisée.",
  "v1.compte.code.CHAMP_GERE_PAR_L_ORGANISATION": "Ce champ est géré par votre organisation.",
  "v1.compte.code.CONDITIONS_VERSION_PERIMEE": "Une version plus récente des conditions est en vigueur : relisez-la.",
  "v1.compte.code.CONFIRMATION_IDENTITE_ECHOUEE": "Secret incorrect : votre identité n’est pas confirmée.",
  "v1.compte.code.CONFIRMATION_IDENTITE_REQUISE": "Confirmez d’abord votre identité (valable 5 minutes).",
  "v1.compte.code.DELEGATION_DELEGATOR_ROLE_MISSING": "Vous ne détenez pas ce rôle ou ce profil dans ce projet.",
  "v1.compte.code.DELEGATION_DROIT_RESERVE": "La propriété et les droits réservés ne se délèguent jamais.",
  "v1.compte.code.DELEGATION_INTROUVABLE": "Cette délégation n’existe pas.",
  "v1.compte.code.DELEGATION_NON_MEMBRE": "Le délégataire n’est pas un membre actif de ce projet.",
  "v1.compte.code.DELEGATION_PERIODE_INVALIDE": "La période va d’un début à une fin future, 90 jours au plus.",
  "v1.compte.code.DELEGATION_SOI_MEME": "On ne se délègue pas son profil à soi-même.",
  "v1.compte.code.DERNIER_PROPRIETAIRE": "Vous êtes le seul propriétaire d’objets : transférez-en la propriété d’abord.",
  "v1.compte.code.DROIT_NON_TENU": "Vous ne détenez pas le droit nécessaire.",
  "v1.compte.code.EXPORT_DEJA_EN_COURS": "Un export de vos données est déjà en cours.",
  "v1.compte.code.EXPORT_EXPIRE": "Le lien de l’export a expiré : relancez un export.",
  "v1.compte.code.EXPORT_INTROUVABLE": "Cet export n’existe pas.",
  "v1.compte.code.JETON_EXPIRATION_PLAFOND": "L’expiration dépasse le plafond de la plateforme.",
  "v1.compte.code.JETON_INTROUVABLE": "Ce jeton n’existe plus.",
  "v1.compte.code.JETON_NOM_DEJA_UTILISE": "Un de vos jetons porte déjà ce nom.",
  "v1.compte.code.JETON_PORTEE_HORS_DROITS": "Une portée choisie dépasse vos droits.",
  "v1.compte.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v1.compte.code.SESSION_COURANTE_EXCLUE": "La session courante ne se ferme pas d’ici.",
  "v1.compte.code.SESSION_INTROUVABLE": "Cette session n’existe plus.",
  "v1.compte.code.STATUT_EXPIRATION_PASSEE": "L’expiration du statut est déjà passée.",
  "v1.compte.code.SUPPRESSION_DEJA_DEMANDEE": "La suppression de votre compte est déjà demandée.",
  "v1.compte.code.TROP_DE_TENTATIVES": "Trop de tentatives : patientez avant de réessayer.",
  "v1.compte.code.VALIDATION_ERROR": "Une valeur saisie est invalide.",
  "v1.compte.conditions.acceptees": "Conditions acceptées.",
  "v1.compte.conditions.accepter": "Accepter les conditions",
  "v1.compte.conditions.aucune": "Aucune version des conditions n’est en vigueur.",
  "v1.compte.conditions.deconnecter": "Se déconnecter",
  "v1.compte.conditions.deja": "Vous avez accepté la version {{version}} le {{date}}.",
  "v1.compte.conditions.echec": "L’acceptation n’a pas été enregistrée.",
  "v1.compte.conditions.libelle": "Conditions d’utilisation",
  "v1.compte.conditions.resume": "Résumé des changements",
  "v1.compte.conditions.suspendu": "Votre parcours reste suspendu tant que les conditions ne sont pas acceptées.",
  "v1.compte.conditions.texte": "Texte complet",
  "v1.compte.conditions.titre": "Accepter les conditions d’utilisation",
  "v1.compte.conditions.version": "Version {{version}}, en vigueur depuis le {{date}}",
  "v1.compte.confirmer.confirmer": "Confirmer",
  "v1.compte.confirmer.echec": "La confirmation a échoué.",
  "v1.compte.confirmer.fenetre": "La confirmation vaut 5 minutes.",
  "v1.compte.confirmer.pour_jeton": "Saisissez votre mot de passe pour créer un jeton personnel.",
  "v1.compte.confirmer.requis": "Saisissez votre secret.",
  "v1.compte.confirmer.secret": "Mot de passe ou code du second facteur",
  "v1.compte.confirmer.texte": "Saisissez votre mot de passe pour confirmer une action sensible.",
  "v1.compte.confirmer.titre": "Confirmer mon identité",
  "v1.compte.consentements.change": "Consentement enregistré.",
  "v1.compte.consentements.donne": "donné",
  "v1.compte.consentements.donner": "Donner mon consentement : {{finalite}}",
  "v1.compte.consentements.echec": "Le consentement n’a pas été changé.",
  "v1.compte.consentements.retire": "retiré",
  "v1.compte.consentements.retirer": "Retirer mon consentement : {{finalite}}",
  "v1.compte.consentements.titre": "Mes consentements aux traitements IA",
  "v1.compte.consentements.vide": "Aucun consentement demandé.",
  "v1.compte.delegations.deleguer": "Déléguer mes profils",
  "v1.compte.delegations.donnee": "Donnée à",
  "v1.compte.delegations.echec": "La délégation n’a pas été révoquée.",
  "v1.compte.delegations.etat.active": "active",
  "v1.compte.delegations.etat.expired": "terminée",
  "v1.compte.delegations.etat.revoked": "révoquée",
  "v1.compte.delegations.etat.scheduled": "à venir",
  "v1.compte.delegations.periode": "du {{debut}} au {{fin}}",
  "v1.compte.delegations.recue": "Reçue de",
  "v1.compte.delegations.revoquee": "Délégation révoquée.",
  "v1.compte.delegations.revoquer": "Révoquer",
  "v1.compte.delegations.revoquer_nom": "Révoquer la délégation de {{espace}}",
  "v1.compte.delegations.titre": "Mes délégations",
  "v1.compte.delegations.vide": "Aucune délégation donnée ni reçue.",
  "v1.compte.deleguer.aucun_espace": "Vous n’êtes membre d’aucun projet : rien à déléguer.",
  "v1.compte.deleguer.aucun_membre": "Aucun autre membre actif dans ce projet.",
  "v1.compte.deleguer.aucun_profil": "Vous ne détenez aucun profil sur ce projet : rien à déléguer.",
  "v1.compte.deleguer.candidats_erreur": "Les membres du projet n’ont pas pu être lus.",
  "v1.compte.deleguer.choisir": "Choisir un membre",
  "v1.compte.deleguer.debut": "Début",
  "v1.compte.deleguer.delegataire": "Délégataire",
  "v1.compte.deleguer.delegataire_requis": "Choisissez le délégataire.",
  "v1.compte.deleguer.deleguer": "Déléguer",
  "v1.compte.deleguer.echec": "La délégation n’a pas été enregistrée.",
  "v1.compte.deleguer.espace": "Projet",
  "v1.compte.deleguer.fin": "Fin",
  "v1.compte.deleguer.motif": "Motif",
  "v1.compte.deleguer.motif_aide": "5 caractères au moins ; tracé avec la délégation.",
  "v1.compte.deleguer.motif_requis": "Le motif compte 5 caractères au moins.",
  "v1.compte.deleguer.periode_aide": "{{jours}} jours au plus.",
  "v1.compte.deleguer.profils": "Profils délégués",
  "v1.compte.deleguer.profils_aide": "Les droits transmis sont ceux des profils cochés, quel que soit le rôle choisi.",
  "v1.compte.deleguer.profils_requis": "Cochez au moins un profil à déléguer.",
  "v1.compte.deleguer.reserve": "La propriété et les droits réservés ne se délèguent jamais.",
  "v1.compte.deleguer.reussie": "Délégation enregistrée.",
  "v1.compte.deleguer.role": "Rôle délégué",
  "v1.compte.deleguer.role.contributor": "Contributeur",
  "v1.compte.deleguer.role.viewer": "Lecteur",
  "v1.compte.deleguer.taches": "Confier mes tâches en cours (approbations et affectations)",
  "v1.compte.deleguer.taches_aide": "Affichées au délégataire pendant la période, rendues à l’échéance.",
  "v1.compte.deleguer.titre": "Déléguer mes profils pendant une absence",
  "v1.compte.donnees.titre": "Mes données",
  "v1.compte.droits_isoles.aucun_espace": "Aucun projet : aucun droit isolé à montrer.",
  "v1.compte.droits_isoles.espace": "Projet",
  "v1.compte.droits_isoles.limites": "Régler les limites d’en-cours",
  "v1.compte.droits_isoles.non_tenue": "non tenu",
  "v1.compte.droits_isoles.recette": "Exécuter la recette",
  "v1.compte.droits_isoles.regression": "Accepter une régression",
  "v1.compte.droits_isoles.tenue": "tenu",
  "v1.compte.droits_isoles.titre": "Droits isolés de recette",
  "v1.compte.droits_isoles.vide": "Aucun droit isolé dans ce projet.",
  "v1.compte.etat.chargement": "Chargement de {{quoi}}…",
  "v1.compte.etat.en_cours": "En cours…",
  "v1.compte.etat.erreur": "{{quoi}} : lecture impossible.",
  "v1.compte.etat.reessayer": "Réessayer",
  "v1.compte.etat.refus": "{{quoi}} : accès refusé.",
  "v1.compte.export.actualiser": "Actualiser",
  "v1.compte.export.echec": "L’export n’a pas été lancé.",
  "v1.compte.export.echec_telechargement": "Le téléchargement de l’archive a échoué.",
  "v1.compte.export.etat.en_cours": "Export en préparation.",
  "v1.compte.export.etat.expire": "Lien expiré : relancez un export.",
  "v1.compte.export.etat.pret": "Archive prête.",
  "v1.compte.export.expire": "lien valable jusqu’au {{quand}}",
  "v1.compte.export.lancer": "Exporter mes données",
  "v1.compte.export.suivi": "Suivi de l’export",
  "v1.compte.export.telecharger": "Télécharger l’archive",
  "v1.compte.fermer": "Fermer",
  "v1.compte.identite.courriel": "Courriel",
  "v1.compte.identite.nom": "Nom",
  "v1.compte.identite.organisation": "Organisation",
  "v1.compte.identite.titre": "Identité",
  "v1.compte.jeton.aucune_portee": "Aucun droit à confier à un jeton.",
  "v1.compte.jeton.confirmer_d_abord": "Confirmez d’abord votre identité : la création d’un jeton l’exige.",
  "v1.compte.jeton.confirmer_lien": "Confirmer mon identité",
  "v1.compte.jeton.copiee": "Valeur copiée.",
  "v1.compte.jeton.copier": "Copier la valeur",
  "v1.compte.jeton.cree": "Jeton « {{nom}} » créé.",
  "v1.compte.jeton.creer": "Créer le jeton",
  "v1.compte.jeton.echec": "Le jeton n’a pas été créé.",
  "v1.compte.jeton.expiration": "Expiration",
  "v1.compte.jeton.fermer_consequence": "Sa valeur sera perdue : il faudra créer un autre jeton.",
  "v1.compte.jeton.fermer_titre": "Fermer sans avoir copié le jeton ?",
  "v1.compte.jeton.fermer_verbe": "Fermer",
  "v1.compte.jeton.nom": "Nom du jeton",
  "v1.compte.jeton.nom_requis": "Donnez un nom au jeton.",
  "v1.compte.jeton.plafond": "{{jours}} jours au plus (jusqu’au {{date}}).",
  "v1.compte.jeton.portee_requise": "Choisissez au moins une portée.",
  "v1.compte.jeton.portees": "Portées (bornées par vos droits)",
  "v1.compte.jeton.titre": "Créer un jeton personnel",
  "v1.compte.jeton.une_seule_fois": "Copiez sa valeur maintenant : elle ne sera plus jamais montrée.",
  "v1.compte.jeton.valeur_vide": "La valeur du jeton apparaîtra ici, une seule fois.",
  "v1.compte.jetons.confirmation_requise": "La création demande de confirmer votre identité.",
  "v1.compte.jetons.creer": "Créer un jeton",
  "v1.compte.jetons.echec": "Le jeton n’a pas été révoqué.",
  "v1.compte.jetons.expire": "expire le {{quand}}",
  "v1.compte.jetons.revoque": "Jeton révoqué.",
  "v1.compte.jetons.revoquer": "Révoquer",
  "v1.compte.jetons.revoquer_nom": "Révoquer le jeton {{nom}}",
  "v1.compte.jetons.titre": "Mes jetons personnels",
  "v1.compte.jetons.vide": "Aucun jeton personnel.",
  "v1.compte.lien_fiche_membre": "Ma fiche de membre",
  "v1.compte.lien_preferences": "Mes préférences",
  "v1.compte.liens": "Liens du compte",
  "v1.compte.niveau.organisation": "organisation",
  "v1.compte.niveau.programme": "programme",
  "v1.compte.niveau.projet": "projet",
  "v1.compte.prefs.affichage": "Affichage et accessibilité",
  "v1.compte.prefs.aucun_espace": "Aucun projet accessible : la vue d’accueil et le mode de navigation se règlent par projet.",
  "v1.compte.prefs.aucun_projet": "Aucun projet accessible : seul le niveau par défaut s’applique.",
  "v1.compte.prefs.contraste_eleve": "Contraste élevé",
  "v1.compte.prefs.daltonisme": "Daltonisme",
  "v1.compte.prefs.daltonisme.aucun": "Aucun réglage",
  "v1.compte.prefs.daltonisme.deuteranopie": "Deutéranopie",
  "v1.compte.prefs.daltonisme.protanopie": "Protanopie",
  "v1.compte.prefs.daltonisme.tritanopie": "Tritanopie",
  "v1.compte.prefs.densite": "Densité",
  "v1.compte.prefs.densite.compacte": "Compacte",
  "v1.compte.prefs.densite.confortable": "Confortable",
  "v1.compte.prefs.echec": "L’enregistrement a échoué.",
  "v1.compte.prefs.enregistrer_mode": "Enregistrer le mode",
  "v1.compte.prefs.enregistrer_notifications": "Enregistrer mes notifications",
  "v1.compte.prefs.enregistrer_reglages": "Enregistrer mes réglages",
  "v1.compte.prefs.enregistrer_vue": "Enregistrer la vue d’accueil",
  "v1.compte.prefs.espace": "Projet",
  "v1.compte.prefs.fuseau": "Fuseau horaire",
  "v1.compte.prefs.fuseau_invalide": "Fuseau IANA attendu (par exemple Africa/Abidjan).",
  "v1.compte.prefs.herite": "Hérité du niveau par défaut",
  "v1.compte.prefs.heures_calmes": "Heures calmes",
  "v1.compte.prefs.heures_calmes.actives": "Activer les heures calmes",
  "v1.compte.prefs.heures_calmes.aide": "Plage quotidienne ; sans réglage, celle de l’organisation s’applique ; une urgence passe toujours.",
  "v1.compte.prefs.heures_calmes.debut": "Début",
  "v1.compte.prefs.heures_calmes.fin": "Fin",
  "v1.compte.prefs.heures_calmes.invalides": "Début et fin distincts requis (HH:MM).",
  "v1.compte.prefs.langue": "Langue",
  "v1.compte.prefs.langue.en": "Anglais",
  "v1.compte.prefs.langue.fr": "Français",
  "v1.compte.prefs.mode": "Mode de navigation",
  "v1.compte.prefs.mode.actuel": "Mode actuel : {{mode}}.",
  "v1.compte.prefs.mode.complete": "Complet",
  "v1.compte.prefs.mode.discovery": "Découverte",
  "v1.compte.prefs.mode_defaut": "Revenir au mode par défaut",
  "v1.compte.prefs.mode_enregistre": "Mode de navigation enregistré.",
  "v1.compte.prefs.mode_par_defaut": "Mode par défaut rétabli.",
  "v1.compte.prefs.mouvement_reduit": "Réduire les animations",
  "v1.compte.prefs.niveau.all": "Tout",
  "v1.compte.prefs.niveau.mentions": "Mentions seulement",
  "v1.compte.prefs.niveau.mute": "Muet",
  "v1.compte.prefs.niveau_defaut": "Niveau par défaut",
  "v1.compte.prefs.niveau_projet": "Niveau par projet",
  "v1.compte.prefs.notifications": "Notifications",
  "v1.compte.prefs.notifications_enregistrees": "Notifications enregistrées.",
  "v1.compte.prefs.par_espace": "Préférences par projet",
  "v1.compte.prefs.raccourcis": "Raccourcis à une seule touche",
  "v1.compte.prefs.raccourcis_aide": "Liste des raccourcis : touche « ? ». Décochez pour les désactiver (WCAG 2.1.4).",
  "v1.compte.prefs.reglages_enregistres": "Réglages enregistrés.",
  "v1.compte.prefs.reinitialiser": "Réinitialiser la vue d’accueil",
  "v1.compte.prefs.reinitialiser_consequence": "Votre choix de vue pour ce projet sera effacé.",
  "v1.compte.prefs.reinitialiser_titre": "Revenir à la vue suggérée ?",
  "v1.compte.prefs.resume": "Résumé des notifications",
  "v1.compte.prefs.resume.actif": "Activé",
  "v1.compte.prefs.resume.creneaux": "Envoyé à {{creneaux}} ({{fuseau}}).",
  "v1.compte.prefs.resume.desactive": "Désactivé",
  "v1.compte.prefs.retour_notifications": "Retour aux notifications",
  "v1.compte.prefs.theme": "Thème",
  "v1.compte.prefs.theme.clair": "Clair",
  "v1.compte.prefs.theme.sombre": "Sombre",
  "v1.compte.prefs.theme.systeme": "Suivre le système",
  "v1.compte.prefs.titre": "Mes préférences",
  "v1.compte.prefs.vue": "Vue d’accueil",
  "v1.compte.prefs.vue.actuelle": "Vue choisie : {{vue}}.",
  "v1.compte.prefs.vue.administration": "Administration",
  "v1.compte.prefs.vue.architecte": "Architecture",
  "v1.compte.prefs.vue.combinee": "Vue combinée",
  "v1.compte.prefs.vue.dev": "Développement",
  "v1.compte.prefs.vue.metier": "Métier",
  "v1.compte.prefs.vue.po": "Responsable produit",
  "v1.compte.prefs.vue.release": "Mise en production",
  "v1.compte.prefs.vue.scrum_master": "Scrum Master",
  "v1.compte.prefs.vue.sponsor": "Sponsor",
  "v1.compte.prefs.vue.suggeree": "Vue suggérée",
  "v1.compte.prefs.vue.testeur": "Test",
  "v1.compte.prefs.vue_enregistree": "Vue d’accueil enregistrée.",
  "v1.compte.prefs.vue_reinitialisee": "Vue d’accueil réinitialisée.",
  "v1.compte.profil.avatar": "Adresse de l’avatar",
  "v1.compte.profil.avatar_aide": "Adresse https:// d’une image.",
  "v1.compte.profil.champ.courriel": "courriel",
  "v1.compte.profil.champ.identifiant": "identifiant",
  "v1.compte.profil.champ.nom": "nom",
  "v1.compte.profil.champ.prenom": "prénom",
  "v1.compte.profil.champ.role_organisation": "rôle dans l’organisation",
  "v1.compte.profil.echec": "Le profil n’a pas été enregistré.",
  "v1.compte.profil.enregistre": "Profil enregistré.",
  "v1.compte.profil.enregistrer": "Enregistrer mon profil",
  "v1.compte.profil.geres": "Gérés par votre organisation, non modifiables ici : {{champs}}.",
  "v1.compte.profil.nom_affiche": "Nom affiché",
  "v1.compte.profil.pronoms": "Pronoms",
  "v1.compte.profil.titre": "Profil personnel",
  "v1.compte.profil.visibilite": "Visibilité du profil",
  "v1.compte.profil.visibilite.organisation": "Toute l’organisation",
  "v1.compte.profil.visibilite.privee": "Privée",
  "v1.compte.profil.visibilite.projets": "Mes projets",
  "v1.compte.sans_organisation": "Votre compte n’est rattaché à aucune organisation.",
  "v1.compte.sessions.autres_fermees": "{{n}} autre(s) session(s) fermée(s).",
  "v1.compte.sessions.courante": "Session courante",
  "v1.compte.sessions.derniere": "dernière activité {{quand}}",
  "v1.compte.sessions.echec": "La session n’a pas été fermée.",
  "v1.compte.sessions.fermee": "Session fermée.",
  "v1.compte.sessions.fermer": "Fermer",
  "v1.compte.sessions.fermer_autres": "Fermer toutes les autres sessions",
  "v1.compte.sessions.fermer_nom": "Fermer la session {{ip}}",
  "v1.compte.sessions.navigateur": "Navigateur",
  "v1.compte.sessions.titre": "Mes sessions",
  "v1.compte.sessions.vide": "Aucune session ouverte.",
  "v1.compte.statut.absent": "Absent",
  "v1.compte.statut.choix": "Statut",
  "v1.compte.statut.deleguer": "Déléguer mes profils pendant l’absence",
  "v1.compte.statut.disponible": "Disponible",
  "v1.compte.statut.echec": "Le statut n’a pas été enregistré.",
  "v1.compte.statut.enregistre": "Statut enregistré.",
  "v1.compte.statut.enregistrer": "Enregistrer mon statut",
  "v1.compte.statut.exclu": "Absent ou occupé, vous êtes exclu des assignations automatiques.",
  "v1.compte.statut.expiration": "Jusqu’au",
  "v1.compte.statut.message": "Message",
  "v1.compte.statut.occupe": "Occupé",
  "v1.compte.statut.titre": "Statut d’absence",
  "v1.compte.suppression.confirmer_titre": "Demander la suppression de votre compte ?",
  "v1.compte.suppression.consequence_admin": "L’administration de l’organisation traitera la demande.",
  "v1.compte.suppression.consequence_anonyme": "Vos contributions seront conservées sous un nom anonyme.",
  "v1.compte.suppression.demandee": "Suppression demandée : l’administration la traitera.",
  "v1.compte.suppression.demander": "Demander la suppression de mon compte",
  "v1.compte.suppression.echec": "La demande n’a pas été enregistrée.",
  "v1.compte.suppression.en_cours": "Suppression demandée le {{quand}}, en attente de l’administration.",
  "v1.compte.suppression.explication": "La suppression est traitée par l’administration ; vos contributions restent, sous un nom anonyme.",
  "v1.compte.suppression.motif": "Motif",
  "v1.compte.suppression.motif_aide": "Facultatif ; de 10 à 1 000 caractères s’il est donné.",
  "v1.compte.suppression.motif_bornes": "Le motif compte de 10 à 1 000 caractères ; la demande n’a pas été envoyée.",
  "v1.compte.suppression.verbe": "Demander",
  "v1.compte.taches.anomalie": "Anomalie",
  "v1.compte.taches.approbation": "Approbation",
  "v1.compte.taches.aucune": "Aucune tâche en cours confiée.",
  "v1.compte.taches.element": "Élément",
  "v1.compte.taches.titre": "Tâches confiées pendant la délégation",
  "v1.compte.titre": "Mon profil et mes accès",
  "v1.compte.version.inconnue": "Version inconnue.",
  "v1.compte.version.texte": "Version {{version}} (révision {{revision}})",
  "v1.compte.version.titre": "Version de l’outil"
}
